import {TableCell} from "@mui/material";
import AppList, {AppListConfig} from "../../../components/layout/list";
import {EmployeeRestControllerApiFactory, Payroll} from "arteco-api-client-ts";
import {useApiManager} from "../../../components/utils/api";
import {dateFromToString} from "../../../components/utils/dates";
import {numberToString} from "../../../components/utils/numbers";
import {fileLocalSave} from "../../../components/form/form_inputs/form_file";
import {useState} from "react";

export const EmployeePayrollPage = () => {
	const apiManager = useApiManager();
	const employeeApi = apiManager.factory(EmployeeRestControllerApiFactory);
	const [showSensible, setShowSensible] = useState<boolean>(false);

	const listConfig: AppListConfig<Payroll> = {
		title: "Listado de nóminas",
		onClick: (payroll) => {
			if (!payroll.id) throw new Error("No payroll id");
			employeeApi.viewEmployeePayroll(payroll.id).then((resp) => fileLocalSave(resp));
		},
		actions: [
			{
				label: "Mostrar datos",
				action: () => {
					setShowSensible(!showSensible);
				}
			}
		],
		headers: [
			{title: "Período"},
			{title: "Líquido"},
			{title: "Coste Empresa"}
		],
		decorator: (bean: Payroll) => (
			<>
				<TableCell>{dateFromToString(bean.periodFrom) + " a " + dateFromToString(bean.periodTo)}</TableCell>
				<TableCell>
					{showSensible && numberToString(bean.totalLiquido)}
					{!showSensible && ("*****")}
				</TableCell>
				<TableCell>
					{showSensible && (numberToString(bean.costeEmpresa))}
					{!showSensible && ("*****")}
				</TableCell>
			</>
		),
		supplier: async (currentPage, size, term, showDismissed) => {
			return employeeApi.getEmployeePayrolls(currentPage, undefined, undefined);
		},
	};

	return (
		<>
			<AppList config={listConfig} searchable={false} appendable={false}/>
		</>
	);
};